<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <EstablishmentPrivilegeForm
      v-if="!isLoading"
      :userEstablishmentPrivilegeDate="userEstablishmentPrivilegeDate"
      :submitName="$t('edit')"
      v-on:updateUserEstablishmentPrivilege="updateUserEstablishmentPrivilege"
      :userType="userType"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import EstablishmentPrivilegeForm from "@/components/privileges/usersPrivileges/EstablishmentPrivilegeForm.vue";
import UsersEstablishmentPrivilege from "@/models/privileges/usersPrivileges/UsersEstablishmentPrivilege";
import createToastMixin from "@/utils/create-toast-mixin";
import { USER_TYPE } from "@/utils/constants";

export default {
  name: "UsersClientPrivileges",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EstablishmentPrivilegeForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      userEstablishmentPrivilegeDate: new UsersEstablishmentPrivilege(),
      userType: USER_TYPE.client,
    };
  },
  methods: {
    async updateUserEstablishmentPrivilege() {
      this.isLoading = true;
      try {
        let response =
          await this.userEstablishmentPrivilegeDate.updateUserEstablishmentPrivilege(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.userEstablishmentPrivilegeDate.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
